import React, { useState, useEffect } from "react";
import {
  list,
  scheduleCharges,
  table,
  SubCharges,
  fetchAllSOC,
} from "../utils/routes";
// import img from "../assets/img/Background.png";
import chargesheroimg from "../assets/img/chargesillustration.svg";
import IconChevron from "../assets/img/icon-chevron.svg";
import playstore from "../assets/img/playstore.svg";
import parse from "html-react-parser";
import { Rings } from "react-loader-spinner";
import Accordion from "react-bootstrap/Accordion";
import moment from "moment/moment";
import { FiDownload } from "react-icons/fi";
import IconPdf from "../assets/img/icon-pdf.png";
import { useMemo } from "react";
import Pagination from "../components/pagination/Pagination";

function Charges() {
  const [schedulepage, setSchedualepage] = useState({
    charges_btn: "",
    charges_desc: "",
    charges_heading: "",
    charges_onezapp_heading: "",
    download_onezapp_app_url: "",
  });
  // const [flag, setFlag] = useState(false);

  // const [subFlag, setSubFlag] = useState(false);
  // const [listId, setListId] = useState(0);
  // const [sublistId, setSublistId] = useState(0);
  const [chargeslist, setChargeslist] = useState({});
  const [listOnezapp, setListOnezapp] = useState({});
  const [listtable, setListtable] = useState({});

  let PageSize = 5;

  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [socData, setSocData] = useState([]);

  async function getAllSOC() {
    try {
      const response = await fetch(fetchAllSOC);
      const data = await response.json();
      // Use the data as needed
      setSocData(data.result);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  }

  // const chanegeSublistdata = (id) => {
  //   var chargeID = {
  //     id: id,
  //   };

  //   const getDataByChargeID = {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify(chargeID),
  //   };
  //   fetch(SubCharges, getDataByChargeID)
  //     .then((res) => res.json())
  //     .then((result) => {
  //       setListtable(result);
  //       var table = JSON.parse(result.charges.onezapp_sub_desc);
  //       setListOnezapp({ table });
  //     });
  // };

  useEffect(() => {
    getAllSOC();
    setLoading(true);
    var chargeID = {
      id: 1,
    };

    const getDataByChargeID = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(chargeID),
    };

    fetch(table, getDataByChargeID)
      .then((res) => res.json())
      .then((result) => {
        setLoading(false);
        setListtable(result);

        var table = JSON.parse(result.charges.onezapp_charge_description);
        setListOnezapp({ table });
      });

    var object = {
      id: 7,
    };

    const getUserRequestDTO = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(object),
    };

    fetch(scheduleCharges, getUserRequestDTO)
      .then((res) => res.json())
      .then((result) => {
        setLoading(false);
        setSchedualepage(result.msg);
      });

    fetch(list)
      .then((res) => res.json())
      .then((result) => {
        setLoading(false);
        setChargeslist(result);
      });
  }, []);

  // const chanegelistdata = (list, id) => {
  //   var chargeID = {
  //     id: list,
  //   };

  //   const getDataByChargeID = {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify(chargeID),
  //   };
  //   fetch(table, getDataByChargeID)
  //     .then((res) => res.json())
  //     .then((result) => {
  //       setListtable(result);

  //       var table = JSON.parse(result.charges.onezapp_charge_description);
  //       setListOnezapp({ table });
  //     });
  // };

  // const parseTableData = (rowData, index) => {
  //   if (listOnezapp?.table?.charges) {
  //     let headers = Object.keys(rowData);
  //     return headers?.map((key, index) => {
  //       return <td style={{}}>{parse(rowData[key])}</td>;
  //     });
  //   }
  // };

  // const renderTableHeader = () => {
  //   if (listOnezapp?.table?.charges[0]) {
  //     let header = Object.keys(
  //       listOnezapp?.table?.charges[0],
  //       listOnezapp?.faqsQueAns?.charges[0]
  //     );
  //     return header?.map((key, index) => {
  //       return (
  //         <th className="th_charges" key={index}>
  //           {parse(key)}
  //         </th>
  //       );
  //     });
  //   }
  // };

  // const renderTableData = () => {
  //   return listOnezapp?.table?.charges?.map((charge, index) => {
  //     return (
  //       <>
  //         <tr className="table__row-charges">
  //           {parseTableData(charge, index)}
  //         </tr>
  //       </>
  //     );
  //   });
  // };

  // const toggleDiv = (e) => {
  //   $("#list_charges").hide();
  // };

  // const getSubCategory = (index) => {
  //   var subId = {
  //     id: index,
  //   };

  //   const getDataBySubChargeID = {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify(subId),
  //   };
  //   fetch(SubCharge, getDataBySubChargeID)
  //     .then((res) => res.json())
  //     .then((result) => {
  //       setSublistId(result.subCharges);
  //     });
  // };

  const socPaginatedData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    // Sort the list by updatedDateTime in descending order (newest first)
    const sortedList = socData?.list?.slice().sort((a, b) => {
      return new Date(b.updatedDateTime) - new Date(a.updatedDateTime);
    });
    return sortedList?.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, socData]);

  console.log(socData, "socData");

  return (
    <div>
      <div className={loading === true ? "overlay" : " "}>
        <p id="loading">
          {loading ? <Rings color="#91298c" height={160} width={160} /> : null}
        </p>
      </div>
      <section className="faq__section-one ">
        <div className="container">
          <div className="row  ">
            <div className="col-sm-12 col-md-6">
              <div className="faq__mainheading">
                <h1>{parse(schedulepage.charges_heading)}</h1>
                <p>{schedulepage.charges_desc}</p>

                <a
                  target="_blank"
                  href="https://play.google.com/store/apps/details?id=com.epSystems.oneZap.android.app"
                  className="btn btn-home-download-zapp mt-2"
                >
                  {schedulepage.charges_btn}
                  <img className="home__playbutton" src={playstore}></img>
                </a>
              </div>
            </div>
            <div className="col-sm-12 col-md-6 order-first order-md-last">
              <center>
                <div>
                  <img className="img-fluid-hero" src={chargesheroimg}></img>
                </div>
              </center>
            </div>
          </div>
        </div>
      </section>

      <section className="soc-wrapper">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h1 className="section-title">
              {parse(schedulepage.charges_onezapp_heading)}
            </h1>
            <p className="charges-date m-0">
              Updated On: {moment(socData?.latestUpdatedDateTime).format("ll")}
            </p>
          </div>
          <div className="soc-list-wrapper">
            <h1>Current and previous SOCs</h1>
            <ul className="soc-list">
              {socPaginatedData ? (
                socPaginatedData?.map((item, index) => {
                  return (
                    <li>
                      <h5 className="doc-name">
                        {item.fileName}{" "}
                        {/* {moment(item.updatedDateTime).format("ll")} */}
                      </h5>
                      <aside>
                        <span className="icon-doc-type">
                          <img src={IconPdf} alt="icon pdf" />
                        </span>
                        <a
                          className="btn"
                          href={`${process.env.REACT_APP_BASE_URL}${item.filePath}`}
                          download={`${item.fileName}.pdf`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <FiDownload /> Download
                        </a>
                      </aside>
                    </li>
                  );
                })
              ) : (
                <li className="text-white">No Data Available</li>
              )}
            </ul>
            <Pagination
              className="pagination-bar"
              currentPage={currentPage}
              totalCount={[socData?.list?.length]}
              pageSize={PageSize}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>

          {/* <div className="row d-none">
            <div className="col-lg-3">
              <div className="list-mobile-charges ">
                <Accordion>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      Schedule of Charges List
                    </Accordion.Header>
                    <Accordion.Body>
                      <div className="charges__list" id="list_charges">
                        <ol className="ul__list">
                          {chargeslist?.msg?.map((list, index) => {
                            return (
                              <li
                                className={`list-item ${
                                  listId == 0 && index == 0
                                    ? "active"
                                    : flag == true && listId == index + 1
                                    ? "active"
                                    : ""
                                }`}
                                onClick={(e) => {
                                  chanegelistdata(index + 1, e.target.id);
                                  setListId(index + 1);
                                  {
                                    flag !== true
                                      ? setFlag(!flag)
                                      : list.onezapp_sub_charges.length
                                      ? setFlag(!flag)
                                      : setFlag(true);
                                  }
                                }}
                              >
                                {list.onezapp_charge_name}{" "}
                                {list.onezapp_sub_charges.length ? (
                                  <img
                                    className="icon-arrow"
                                    src={IconChevron}
                                    alt="icon"
                                  />
                                ) : (
                                  ""
                                )}
                                <br></br>
                                {list.onezapp_sub_charges.length != 0 ? (
                                  <ul className="submenu">
                                    {list.onezapp_sub_charges.map(
                                      (index, obj) => (
                                        <li
                                          onClick={() => {
                                            chanegeSublistdata(obj + 1);
                                            setSubFlag(!subFlag);
                                            setSublistId(obj + 1);
                                          }}
                                          className={
                                            subFlag == true &&
                                            sublistId == obj + 1
                                              ? "active"
                                              : ""
                                          }
                                        >
                                          {index.onezapp_sub_charge_name}
                                        </li>
                                      )
                                    )}
                                  </ul>
                                ) : null}
                              </li>
                            );
                          })}
                        </ol>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
              <div className="charges-web">
                <div className="charges__list">
                  <center>
                    <h5 className="charges__list-h">
                      Schedule of Charges List
                    </h5>
                  </center>
                  <ol className="ul__list">
                    {chargeslist?.msg?.map((list, index) => {
                      return (
                        <li
                          style={{ cursor: "pointer" }}
                          className={`list-item ${
                            listId == 0 && index == 0
                              ? "active"
                              : flag === true && listId == index + 1
                              ? "active"
                              : ""
                          }`}
                          onClick={(e) => {
                            chanegelistdata(index + 1, e.target.id);
                            {
                              flag !== true
                                ? setFlag(!flag)
                                : list.onezapp_sub_charges.length
                                ? setFlag(!flag)
                                : setFlag(true);
                            }

                            setListId(index + 1);
                          }}
                        >
                          {list.onezapp_charge_name}{" "}
                          {list.onezapp_sub_charges.length ? (
                            <img
                              className="icon-arrow"
                              src={IconChevron}
                              alt="icon"
                            />
                          ) : (
                            ""
                          )}
                          <br></br>
                          {list.onezapp_sub_charges.length != 0 ? (
                            <ul className="submenu">
                              {list.onezapp_sub_charges.map((index, obj) => {
                                return (
                                  <li
                                    onClick={() => {
                                      chanegeSublistdata(obj + 1);
                                      setSubFlag(true);
                                      setSublistId(obj + 1);
                                    }}
                                    className={
                                      subFlag == true && sublistId == obj + 1
                                        ? "active"
                                        : ""
                                    }
                                  >
                                    {index.onezapp_sub_charge_name}
                                  </li>
                                );
                              })}
                            </ul>
                          ) : null}
                        </li>
                      );
                    })}
                  </ol>
                </div>
              </div>
            </div>
            <div className="col-lg-9 px-0">
              <div className=" table-charges">
                <table
                  id="charges"
                  className="table sortable table-responsive "
                >
                  <thead>
                    <tr>{renderTableHeader()}</tr>
                  </thead>
                  <tbody>{renderTableData()}</tbody>
                </table>
                {}{" "}
              </div>
            </div>
          </div> */}
        </div>
      </section>
    </div>
  );
}

export default Charges;
